import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Box,
  ButtonIcon,
  Icon,
  type IconRotate,
  Loader,
  Typography,
} from '@saviynt/design-system';

import { MarkDown } from '../../../../shared/components';
import { CF_SAV_BLD, CHAT_BLOCK } from '../../../../shared/constants';
import { type GeneratingBlocks } from '../../../../shared/types';

import ResponseWrapper from './ResponseWrapper';

interface ResponseProgressBarProps {
  id: string;
  block: GeneratingBlocks;
  scrollToBottom?: () => void;
}

/**
 * ResponseProgressBar
 */
function ResponseProgressBar({
  id,
  block,
  scrollToBottom,
}: ResponseProgressBarProps) {
  const [isActionVisible, setIsActionVisible] = useState(true);

  const isProgressBlock = Boolean(block.type === CHAT_BLOCK.PROGRESS);

  return (
    <ResponseWrapper id={id}>
      {isProgressBlock ? (
        <>
          <Box tag='div' className='ResponseProgressBar-loader'>
            <Loader kind='dots' size='small' format='inline' color='brand' />
            <Typography kind='body2' color={CF_SAV_BLD}>
              <FormattedMessage
                id='PWYBOH'
                defaultMessage='Responding. This may take a moment'
                description='Responding. This may take a moment'
              />
            </Typography>
            <ButtonIcon
              size='small'
              kind='saviGhost'
              ariaLabel={isActionVisible ? 'Collapse' : 'Expand'}
              icon={
                <Icon
                  kind='ChevronDown'
                  size='xSmall'
                  rotate={(isActionVisible ? '0' : '180') as IconRotate}
                />
              }
              onClick={() => {
                setIsActionVisible((prev) => !prev);

                if (scrollToBottom) {
                  scrollToBottom();
                }
              }}
            />
          </Box>
          {isActionVisible && block.content.trim().length > 0 && (
            <Box tag='div' className='ResponseProgressBar-loaderText'>
              <MarkDown isAssistant isAction>
                {block.content}
              </MarkDown>
            </Box>
          )}
        </>
      ) : (
        <Box tag='div' className='ResponseProgressBar-errorText'>
          <MarkDown isAssistant>{block.content}</MarkDown>
        </Box>
      )}
    </ResponseWrapper>
  );
}

ResponseProgressBar.defaultProps = {
  scrollToBottom: undefined,
};

export default ResponseProgressBar;
